import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { IMachineItem, MachineConfigUtils } from '../../../pages/dashboard-page/widgets/machine-view/machine-config-utils';
import { BehaviorSubject, map, Observable, of, Subject, Subscription, takeUntil, tap } from 'rxjs';
import { RemoteDataWrapperService } from '../../services/remote-data/remote-data-wrapper.service';
import { DxTooltipModule, DxTreeListModule } from 'devextreme-angular';
import { CommonModule, DecimalPipe, registerLocaleData } from '@angular/common';
import { PipesModule } from 'acl-cloud-lib';
import localeFr from '@angular/common/locales/fr';

@Component({
  selector: 'machine-structure-tree-list',
  standalone: true,
  imports: [DxTreeListModule, CommonModule, PipesModule, DxTooltipModule],
  providers: [DecimalPipe],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './machine-structure-tree-list.component.html',
  styleUrl: './machine-structure-tree-list.component.scss'
})
export class MachineStructureTreeListComponent implements OnDestroy {

  public machineStructure: IMachineItem[] = [];
  public machineStructureIsLoading: boolean = false;

  private _machineVariables: Map<number, BehaviorSubject<string | number | boolean | any[] | null>> = new Map();
  private _machineStructureSub: Subject<any> = new Subject<any>();
  private _machineStructureSubs: Subscription = new Subscription();
  private _machineName?: string;

  @Input() public height: string = '100%';

  @Input() public set machineName(name: string | undefined) {
    if (name && this._machineName !== name) {
      // Get machine structure
      if (this._machineStructureSubs) {
        this._machineStructureSubs.unsubscribe();
      }

      if (this._machineName && this._machineName !== "") {
        this._remoteDataWrapperService.watchRemoteDataUpdates(this._machineName, false);
      }

      this._remoteDataWrapperService.watchRemoteDataUpdates(name, true);

      this._machineStructureSubs = this._remoteDataWrapperService.getMachineStructureRaw(name).pipe(
        takeUntil(this._machineStructureSub)
      ).subscribe((machineStructureRaw) => {
        if (machineStructureRaw && machineStructureRaw !== '{}') {
          this.machineStructure = MachineConfigUtils.resolveMachineConfigurationStructure(machineStructureRaw);
          this._machineVariables = this._remoteDataWrapperService.getClient(name).getMachineOne().machineVariables;
          this.machineStructureIsLoading = true;
        }
      });
    }

    this._machineName = name;
  }

  constructor(
    private readonly _remoteDataWrapperService: RemoteDataWrapperService,
    private readonly _decimalPipe: DecimalPipe
  ) {
    registerLocaleData(localeFr, 'fr-FR');
  }

  ngOnDestroy(): void {
    this._machineStructureSub.unsubscribe();
  }

  getObservableValue(valueId: number): Observable<any> {
    const subject = this._machineVariables.get(valueId);
    if (subject) {
      return subject.asObservable().pipe(
        map(value => {
          if (typeof value === 'number') {
            return this._decimalPipe.transform(value, '1.0-2', 'fr-FR');
          }
          return value;
        })
      );
    }
    return of(null);
  }
}
